var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_vm._v("\n  Free shipping on all orders over $100!\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }